import {configureStore} from "../../__snowpack__/pkg/@reduxjs/toolkit.js";
import {useDispatch} from "../../__snowpack__/pkg/react-redux.js";
import whiteLabel from "./white-label/white-label.slice.js";
import filters from "./filters/filters.slice.js";
const store = configureStore({
  reducer: {
    whiteLabel,
    filters
  }
});
export default store;
export const useAppDispatch = () => useDispatch();
